export default class Kpi {
  constructor(kpi = {}) {
    this.key = kpi.key ? kpi.key : `${kpi.id}-${kpi.productionUnitId}-${kpi.system}`;
    this.indicatorId =  kpi.id ? kpi.id : ``;
    this.indicatorName = kpi.indicatorName ? kpi.indicatorName : "-";
    this.system = kpi.system ? kpi.system : '';
    this.productionUnitId = kpi.productionUnitId ? kpi.productionUnitId : '';
    
  }
}